export default __webpack_public_path__ + "static/media/speed-map.a745af8b.svg";